import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Escape } from '../../../../services/Escape';
import { useDisablePageScroll } from '../../../../internal/hooks/useDisablePageScroll';
/**
 * Компонента для рендера модальных окон
 */
export var Modal = /*#__PURE__*/React.memo(function (_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    children = _ref.children,
    escape = _ref.escape;
  var host = typeof document !== 'undefined' ? document.body : null;
  useDisablePageScroll(open);
  if (!host || !open) {
    return null;
  }
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(Escape, {
    onEscape: onClose,
    active: !!escape
  }, children), host);
});
Modal.displayName = 'Modal';
Modal.defaultProps = {
  escape: true
};